import { Badge, Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import MoneyHelper from "Helpers/MoneyHelper";
import React from "react";
import { FaMoneyBill } from "react-icons/fa";

function Transaction({ transaction }) {
    const textColor = useColorModeValue("gray.700", "white");

    function getColorScheme(status) {
        switch (status.toString()) {
            // Mercado Pago status codes
            case "approved":
            case "authorized":
                return "green";
            case "pending":
            case "in_process":
                return "blue";
            case "in_mediation":
                return "yellow";
            case "rejected":
            case "cancelled":
            case "refunded":
            case "charged_back":
                return "red";
            // Legacy PagSeguro codes (for old transactions)
            case "0":
            case "3":
            case "4":
                return "green";
            case "1":
                return "blue";
            case "5":
            case "9":
            case "2":
                return "yellow";
            default:
                return "gray";
        }
    }

    const bgColor = useColorModeValue("white", "gray.700");
    const borderColor = useColorModeValue("gray.200", "gray.600");

    return (
        <Flex
            my="1rem"
            justifyContent="space-between"
            p={4}
            bg={bgColor}
            borderRadius="xl"
            border="1px solid"
            borderColor={borderColor}
            transition="all 0.2s"
            _hover={{
                shadow: "md",
                transform: "translateY(-2px)"
            }}
        >
            <Flex alignItems="center">
                <Box me="12px" borderRadius="lg" color={"green.400"} bg="green.50" _dark={{ bg: "green.900" }} display="flex" alignItems="center" justifyContent="center" w="40px" h="40px">
                    <Icon as={FaMoneyBill} boxSize={5} />
                </Box>
                <Flex direction="column">
                    <Text fontSize={{ sm: "md", md: "lg", lg: "md" }} color={textColor} fontWeight="semibold">
                        Assinatura
                    </Text>
                    <Text fontSize={{ sm: "xs", md: "sm", lg: "xs" }} color="gray.500" fontWeight="medium">
                        {transaction.days} Dias - {transaction.created_at}
                    </Text>
                </Flex>
            </Flex>
            <Box color={textColor} textAlign={"right"}>
                <Text fontSize={{ sm: "md", md: "lg", lg: "md" }} fontWeight="bold">
                    {MoneyHelper.format(transaction.amount)}
                </Text>
                <Text fontSize={{ sm: "xs", md: "sm", lg: "xs" }} fontWeight="semibold">
                    <Badge colorScheme={getColorScheme(transaction.status)} fontWeight="semibold" borderRadius="full" px={3}>
                        {transaction.status_name}
                    </Badge>
                </Text>
            </Box>
        </Flex>
    );
}

export default Transaction;
